/*
 * @Author: huguantao1@jd.com
 * @Date: 2025-06-18 00:13:36
 * @LastEditors: huguantao1@jd.com
 * @LastEditTime: 2025-07-07 21:11:44
 * @FilePath: /intl-pc-jdi-website-ssr/src/utils/login/JDCloudSlideUtils.js
 * @Description: default
 */
import i18next from "i18next";
class JDCloudSlideUtils {
  
  instance = null;
  options = null;
  onLoad = null;
  onSuccess = null;
  onFailure = null;
  onCancel = null;

  constructor(t) {
    this.options = {
      sessionId: "",
      language: t("static.login.slider.lang"),
      onLoad: (ret) => this.handleOnLoad(ret),
      onSuccess: (ret) => this.handleOnSuccess(ret),
      onFailure: (ret) => this.handleOnFailure(ret),
      onCancel: (ret) => this.handleOnCancel(ret),
    };
  }

  initJDCloudSlideInstance(callbackFn) {
    if (this.instance) {
      return;
    }
    if (window.captchaLoadJS) {
      window.captchaLoadJS(this.options, (obj) => {
        this.instance = obj;
        callbackFn && callbackFn();
      });
    }
  }

  static getInstance(t) {
    if (!this._instance) {
      this._instance = new JDCloudSlideUtils(t || i18next.t);
    }
    return this._instance;
  }
  /**
   * @desc 回调函数处理
   */
  handleOnLoad(ret) {
    this.onLoad && this.onLoad(ret);
    const captchaDom = document.getElementById('captcha_dom');
    if (captchaDom) {
      captchaDom.style.zIndex = '2000';
      captchaDom.style.position = 'fixed';
    }
  }
  handleOnSuccess(ret) {
    this.onSuccess && this.onSuccess(ret.vt);
  }
  handleOnFailure(ret) {
    this.onFailure && this.onFailure(ret?.msg);
  }
  handleOnCancel(ret) {
    this.onCancel && this.onCancel(ret);
  }
  /**
   * @desc 获取sessionId
   * @param onSuccess { Function } 成功回调操作
   * @param onFailure { Function } 失败回调操作
   * [注] 若服务端正常返回sessionId，则直接初始化图形校验SDK；若服务端返回200且code=10000，表示服务端调用图形校验接口出现异常，则直接发送验证码
   * [Note] If the server returns the sessionId normally, the graphics verification SDK will be initialized directly; if the server returns 200 and code=10000, it means that an exception occurs when the server calls the graphics verification interface, and the verification code will be sent directly.
   */
  async initJDSlide(sessionId, onSuccess, onFailure, onCancel, onLoad) {
    if (!window.captchaLoadJS) {
      const head = document.getElementsByTagName("head")[0];
      const script = document.createElement("script");
      script.type = "text/javascript";
      script.src = "https://captcha.joybuy.com/home/requireCaptchaPc.js";

      script.onload = () => {
        this.onInitJDCloudSlide(sessionId, onSuccess, onFailure, onCancel, onLoad);
      };
      script.onerror = () => {
        onFailure("Abnormal loading of graphic verification SDK");
      };
      head.appendChild(script);
    } else {
      this.onInitJDCloudSlide(sessionId, onSuccess, onFailure, onCancel, onLoad);
    }
  }
  async onInitJDCloudSlide(sessionId, onSuccess, onFailure, onCancel, onLoad) {
    this.onSuccess = onSuccess;
    this.onFailure = onFailure;
    this.onCancel = onCancel;
    this.onLoad = onLoad || null;
    this.initJDCloudSlide(sessionId);
  }
  /**
   * @desc 初始化图形校验SDK(Initialize graphics verification SDK)
   * @param sessionId { String } 获取服务器得到的sessionId(Get the sessionId obtained by the server)
   */
  initJDCloudSlide(sessionId) {
    this.options.sessionId = sessionId;
    if (this.instance) {
      typeof this.instance.create === "function" &&
        this.instance.create({
          sessionId: sessionId,
        });
    } else {
      this.initJDCloudSlideInstance(() => {
        typeof this.instance.create === "function" &&
          this.instance.create({
            sessionId: sessionId,
          });
      });
    }
  }
}
export default JDCloudSlideUtils;
